module.exports = __webpack_public_path__ + "img/图.da2625a2.webp";